<template>
    <div>
        <notifications />
        <p v-if="verifying">Verifying your details . . .</p>
        <p v-else>We are facing issues verifying your details. Please goto <router-link to="/">verification page</router-link> to verify manually.</p>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'AutoVerify',
    data () {
        return {
            token: this.$route.query.token,
            verifying: true
        }
    },
    created () {
        this.doVerify()
    },
    methods: {
        doVerify() {
            if (typeof(this.token) !== 'undefined' && this.token) {
                let decodedStr = atob(this.token);
                this.verifyDetails(decodedStr)
            } else {
                this.$router.push({ name: 'verify' })
            }
        },
        verifyDetails (qs) {
            this.$root.loading = true;   
            this.verifying = true;
            const formElems = new URLSearchParams(qs)

            let postFormFields = {
                booking_ref_no: formElems.get('booking_ref_no'),
                surname: formElems.get('surname'),
                departure_date: formElems.get('departure_date'),
            }
            
            axios.post(this.$root.$api + 'manage-bookings/verify', postFormFields)
            .then(res => res.data)
            .then(json => {
                this.$root.loading = false;
                if (typeof(json.success) === 'undefined' || !json.success) {
                    this.$notify({
                        type: 'error',
                        title: json.error
                    });
                    this.verifying = false;
                    return;
                }
                localStorage.setItem('verify', JSON.stringify(json.data.verify));
                this.$router.push({ name: 'manage-booking' , query: { changeVerification: formElems.get('changeVerification')}})
                // this.$router.push({ name: 'manage-booking'})
                $("html, body").animate({ scrollTop: 0 }, "slow");
            })
            .catch( function (error) {
                this.$root.loading = false;
                this.verifying = false;
                this.$notify({
                    type: 'error',
                    title: 'An error occured!'
                });
            })
            
        }
    }
}
</script>